import { render, staticRenderFns } from "./StudentStabilityReport.vue?vue&type=template&id=2d7e92a4"
import script from "./StudentStabilityReport.vue?vue&type=script&lang=js"
export * from "./StudentStabilityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports